.infobanner_wrapper {
  align-items: center;
  background-color: var(--color-grey-300);
  border-left: 0.5rem solid var(--color-grey-600);
  display: flex;
  gap: 1rem;
  padding: 1rem;
  width: 100%;
}
